<template>
  <a-row>
    <a-row> 
      <a-form layout='inline' :label-col="{span: 4}" :wrapper-col="{span: 20}">
        <a-row> 
          <a-row :gutter='48'>
            <a-col :lg='6' :md='8' :sm='24'>
              <a-form-item label="出版社" class="flex-item">
                <a-select allowClear v-model="queryData.publisherCompanyId" placeholder='入学学年 请选择'>
                  <a-select-option v-for="publisherCompany in publisherCompanyList" :key="publisherCompany.id">
                    {{ publisherCompany.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :lg='6' :md='8' :sm='24'>
              <a-form-item label="学季" class="flex-item">
                <a-select allowClear v-model="queryData.eduStage" placeholder='学季 请选择'>
                  <a-select-option :value="1">
                    中职
                  </a-select-option>
                  <a-select-option :value="2">
                    高职
                  </a-select-option>
                  <a-select-option :value="3">
                    中高职
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :lg='6' :md='8' :sm='24'>
              <a-form-item label="作者" class="flex-item">
                <a-input placeholder="请填写作者" v-model="queryData.author"/>
              </a-form-item>
            </a-col>
            <a-col :lg='6' :md='8' :sm='24'>
              <a-form-item label="书名" class="flex-item">
                <a-input-search placeholder="请填写书名" v-model="queryData.title" enter-button @search="searchTextbook"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row> 
            <a-col :span="2" :offset="22">
              <CommonPermissions :p="$permissions.TEXTBOOK.CREATE"> 
                <a-button type="primary" @click="() => triggerEditModal()">
                  添加教材
                </a-button>
              </CommonPermissions>
            </a-col>
          </a-row>
        </a-row>
      </a-form>
    </a-row>
    <!-- <a-col span="4">
      <a-directory-tree :treeData="textbookCategory" default-expand-all @select="selectCategory"/>
    </a-col> -->
    <a-col span="24">
      <a-tabs @change="changeTab" :activeKey="activeStatKey">
        <a-tab-pane v-for="item in auditStatusStat" :key="item.label">
          <span slot="tab">
            {{item.label}}
            <a-badge v-if="item.count > 0" :count="item.count" />
          </span>
          <a-row>
            <a-table :columns="columns" :data-source="textbookList" :loading="loading" :pagination="{current: currentPage, total: total, pageSize: 12}" @change="changePage">
              <div slot="thumb" slot-scope="text, record">
                <img
                  class="thumb-cell thumb-clickable"
                  :src="record.thumbUrl || defaultThumb"
                  alt=""
                  title="点击查看大图"
                  @click="openThumbPreview(record)"
                />
              </div>
              <span slot="status" slot-scope="text, record">
                <a-tag v-if="record.status == 0" color="blue">
                  待发布
                </a-tag>
                <a-tag v-if="record.status == 1" color="green">
                  已发布
                </a-tag>
                <a-tag v-if="record.status == 2" color="red">
                  已下线
                </a-tag>
              </span>
              <span slot="bookFormat" slot-scope="text, record">
                {{ getBookFormatLabel(record.bookFormat) }}
              </span>
              <span slot="action" slot-scope="text, textbook">
                <!-- <CommonPermissions v-if="!textbook.latestVersion || (textbook.latestVersion.auditStatus <= 0)" :p="$permissions.TEXTBOOK.UPDATE"> -->
                <CommonPermissions :p="$permissions.TEXTBOOK.UPDATE">
                    <a @click="() => triggerEditModal(textbook.id)">本书信息</a>
                </CommonPermissions>
                <!-- <CommonPermissions :p="$permissions.TEXTBOOK.UPDATE">
                  <a-divider type="vertical" />
                  <a @click="() => openCategoryTagModal(textbook)">上架分类</a>
                </CommonPermissions> -->
                <!-- <CommonPermissions v-if="!textbook.latestVersion || (textbook.latestVersion.auditStatus <= 0)" :p="$permissions.TEXTBOOK.UPDATE"> -->
                <CommonPermissions :p="$permissions.TEXTBOOK.UPDATE">
                  <a-divider type="vertical" />
                  <a @click="() => goTextbookEdit(textbook.id)">编辑章节</a>
                </CommonPermissions>
                <CommonPermissions v-if="textbook.latestVersion && textbook.latestVersion.auditStatus == 1" :p="$permissions.TEXTBOOK.AUDIT">
                  <a-divider type="vertical" />
                  <a @click="() => goTextbookAudit(textbook)">审核教材</a>
                </CommonPermissions>
                <CommonPermissions v-if="textbook.latestVersion && textbook.latestVersion.auditStatus == 2 && textbook.latestVersion.onlineStatus != 1" :p="$permissions.TEXTBOOK.RELEASE">
                  <a-divider type="vertical" />
                  <a-popconfirm
                    class="edit-btn"
                    title="确认发布此教材？"
                    ok-text="是"
                    cancel-text="否"
                    @confirm="() => confirmPublich(textbook)">
                      <a type="primary" class="edit-btn" icon="form" >发布</a>
                  </a-popconfirm>
                </CommonPermissions>
                <!-- <CommonPermissions v-if="textbook.latestVersion && textbook.latestVersion.auditStatus == 1" :p="$permissions.TEXTBOOK.UPDATE">
                  <a-divider type="vertical" />
                  <a @click="() => withdrawVersion(textbook)">撤回教材</a>
                </CommonPermissions> -->
                <!-- <CommonPermissions :p="$permissions.TEXTBOOK.DELETE">
                  <a-divider type="vertical" />
                  <a-popconfirm
                    title="确认删除教材？"
                    ok-text="是"
                    cancel-text="否"
                    @confirm="() => deleteTextbook(textbook.id)">
                    <a style="color: red">删除</a>
                  </a-popconfirm>
                </CommonPermissions> -->
              </span>
            </a-table>
          </a-row>
        </a-tab-pane>
      </a-tabs>
      <a-row>
        <a-col span="18" style="padding-left: 20px">
          <!-- <a-input-search placeholder="输入教材名搜索教材" v-model="searchKey" enter-button @search="searchTextbook" /> -->
        </a-col>
        <a-col span="4" style="text-align: right;padding-right: 20px;">
          <a-drawer
            width="80%"
            title="编辑教材"
            placement="right"
            :closable="false"
            :visible="showEditModal"
            @close="() => triggerEditModal()">
              <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-form-model-item label="教材名称">
                  <a-input v-model="form.title" />
                </a-form-model-item>
                <a-form-model-item label="学段">
                  <a-select v-model="form.eduStage" style="width: 100%">
                    <a-select-option :value="1">
                      中职
                    </a-select-option>
                    <a-select-option :value="2">
                      高职
                    </a-select-option>
                    <a-select-option :value="3">
                      中高职
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item label="作者">
                  <a-input v-model="form.authors" />
                </a-form-model-item>
                <a-form-model-item label="主编">
                  <a-input v-model="form.chiefEditor" />
                </a-form-model-item>
                <a-form-model-item label="副主编">
                  <a-input v-model="form.deputyEditor" />
                </a-form-model-item>
                <a-form-model-item label="参编人员">
                  <a-input v-model="form.contributingAuthors" />
                </a-form-model-item>
                <a-form-model-item label="ISBN">
                  <a-input v-model="form.isbn" />
                </a-form-model-item>
                <a-form-model-item label="电子书格式">
                  <a-select v-model="form.bookFormat" placeholder="请选择" style="width: 100%">
                    <a-select-option v-for="item in bookFormatOptions" :key="item.value" :value="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item label="是否AI教材">
                  <a-switch v-model="form.aiTextbook" />
                </a-form-model-item>
                <a-form-model-item label="规划教材类型">
                  <a-select v-model="form.standardType" placeholder="请选择" style="width: 100%">
                    <a-select-option :value="0">无</a-select-option>
                    <a-select-option :value="1">国规</a-select-option>
                    <a-select-option :value="2">省规</a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item label="售价">
                  <a-input v-model="form.price" />
                </a-form-model-item>
                <a-form-model-item label="出版单位">
                  <a-input v-model="form.publishers" />
                </a-form-model-item>
                <a-form-model-item label="出版社">
                  <a-select v-model="form.publisherCompanyId" allow-clear style="width: 100%" placeholder="请选择">
                    <a-select-option v-for="p in publisherCompanyList" :key="p.id" :value="p.id">{{ p.name }}</a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item label="制作单位">
                  <a-input v-model="form.producer" />
                </a-form-model-item>
                <a-form-model-item label="版本号">
                  <a-input v-model="form.versionNum" />
                </a-form-model-item>
                <a-form-model-item label="版次">
                  <a-input v-model="form.edition" />
                </a-form-model-item>
                <a-form-model-item label="教材联系">
                  <a-input v-model="form.contactInfo" />
                </a-form-model-item>
                <a-form-model-item label="教材简介">
                  <a-input v-model="form.summary" type="textarea" :autoSize="{maxRows: 10}"/>
                </a-form-model-item>
                <a-form-model-item label="版权声明">
                  <a-input v-model="form.copyrightStatement" type="textarea" :autoSize="{maxRows: 10}"/>
                </a-form-model-item>
                <!-- <a-form-model-item label="分类">
                  <a-cascader :options="textbookCategory" v-model="form.categoryIds" />
                </a-form-model-item> -->
                <a-form-model-item label="封面">
                  <Upload @changeImgUri="changeImgUri" :defaultUrl="form.thumbUrl"/>
                </a-form-model-item>
                <a-form-model-item label="备注">
                  <a-input v-model="form.note" type="textarea" :autoSize="{minRows: 3}"/>
                </a-form-model-item>
                <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                  <a-button type="primary" @click="saveTextbook">
                    保存
                  </a-button>
                  <a-button style="margin-left: 10px;" @click="() => triggerEditModal()">
                    取消
                  </a-button>
                </a-form-model-item>
              </a-form-model>
          </a-drawer>
        </a-col>
      </a-row>
      <a-modal
        title="教材分类与标签"
        :visible="showCategoryTagModal"
        :confirm-loading="categoryTagSubmitting"
        @ok="saveCategoryAndTag"
        @cancel="closeCategoryTagModal"
      >
        <a-form-model :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
          <a-form-model-item label="教材类型">
            <a-select v-model="categoryTagForm.bookType" @change="handleCategoryBookTypeChange">
              <a-select-option :value="1">数字教材</a-select-option>
              <a-select-option :value="2">电子书</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="教材分类">
            <a-select
              v-model="categoryTagForm.categoryIds"
              mode="multiple"
              :maxTagCount="6"
              allowClear
              @change="handleCategoryChange"
              placeholder="请选择教材分类"
            >
              <a-select-option v-for="item in categoryOptions" :key="item.value" :value="item.value">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="教材标签">
            <a-select
              v-model="categoryTagForm.tagIds"
              mode="multiple"
              :maxTagCount="6"
              allowClear
              placeholder="请选择教材标签"
            >
              <a-select-option v-for="item in tagOptions" :key="item.value" :value="item.value">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <a-modal
        :visible="thumbPreviewVisible"
        :footer="null"
        centered
        width="720px"
        :title="thumbPreviewTitle"
        @cancel="closeThumbPreview"
      >
        <div class="thumb-preview-wrap">
          <img class="thumb-preview-img" :src="thumbPreviewUrl" alt="" />
        </div>
      </a-modal>
      <div style="margin-top: 10px;">
        
        <!-- <a-row>
          <a-col style="padding: 20px;" span="4" v-for="textbook in textbookList" :key="textbook.id">
            <a-card hoverable style="width: 100%;">
              <img
                slot="cover"
                style="width:100%;height: 200px;"
                :src="textbook.thumbUrl || 'https://fm-cloud-general-uestcp.oss-cn-chengdu.aliyuncs.com/common/no_thumb.png'"/>
              <a-card-meta :title="textbook.title" style="height: 70px;">
                <div slot="description" style="font-size: 12px;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">
                  {{textbook.summary}}
                </div>
              </a-card-meta>
              <template slot="actions" v-if="textbook.status != 2" class="ant-card-actions">
                <CommonPermissions :p="$permissions.TEXTBOOK.UPDATE">
                  <a-icon key="edit" type="edit" @click="() => triggerEditModal(textbook.id)"/>
                </CommonPermissions>
                <CommonPermissions :p="$permissions.TEXTBOOK.UPDATE">
                  <a-icon type="book" key="book" @click="() => goTextbookEdit(textbook.id)"/>
                </CommonPermissions>
                <CommonPermissions :p="$permissions.TEXTBOOK.DELETE">
                  <a-popconfirm
                    title="确认删除教材？"
                    ok-text="是"
                    cancel-text="否"
                    @confirm="() => deleteTextbook(textbook.id)">
                    <a-icon  type="delete" key="delete"/>
                  </a-popconfirm>
                </CommonPermissions>
              </template>
              <template v-else slot="actions" class="ant-card-actions">
                <a-icon  type="delete" key="delete"/>
              </template>
            </a-card>
          </a-col>
        </a-row> -->
      </div>
    </a-col>
  </a-row>
</template>
<script>
import Upload from '../../../components/Upload.vue'
import CommonPermissions from '@/components/CommonPermissions'
import { mapState } from 'vuex'
import TextBookApi from '../../../api/src/textbook/api/TextBookApi'
import DictApi from '../../../api/src/basic/api/DictApi'
import { buildCategoryDisplayOptions } from '@/utils/textbookCategoryOptions'
const textBookApi = new TextBookApi();
const dictApi = new DictApi()
const defaultThumb = 'https://fm-cloud-general-uestcp.oss-cn-chengdu.aliyuncs.com/common/no_thumb.png'

const bookFormatOptions = [
  { value: 0, label: 'App' },
  { value: 100, label: '自建H5' },
  { value: 101, label: '第三方H5' },
  { value: 200, label: 'PDF' },
]

function getBookFormatLabel(value) {
  const item = bookFormatOptions.find((option) => option.value === Number(value))
  return item ? item.label : '-'
}

function getEmptyTextbookForm() {
  return {
    id: undefined,
    title: '',
    eduStage: undefined,
    authors: '',
    chiefEditor: '',
    deputyEditor: '',
    contributingAuthors: '',
    isbn: '',
    price: '',
    publishers: '',
    publisherCompanyId: undefined,
    producer: '',
    versionNum: '',
    edition: '',
    contactInfo: '',
    summary: '',
    copyrightStatement: '',
    copyright: '',
    categoryId: 102,
    categoryIds: undefined,
    thumbUri: undefined,
    thumbUrl: '',
    note: '',
    aiTextbook: false,
    standardType: 0,
    bookFormat: 0,
  }
}

const columns = [
  {
    dataIndex: 'thumb',
    title: '封面',
    key: 'thumb',
    scopedSlots: { customRender: 'thumb' },
  },
  {
    dataIndex: 'title',
    title: '教材名称',
    key: 'title',
  },
  {
    dataIndex: 'bookFormat',
    title: '电子书格式',
    key: 'bookFormat',
    scopedSlots: { customRender: 'bookFormat' },
  },
  // {
  //   title: '教材简介',
  //   width: '40%',
  //   dataIndex: 'summary',
  //   key: 'summary',
  // },
  // {
  //   title: '状态',
  //   key: 'status',
  //   dataIndex: 'status',
  //   scopedSlots: { customRender: 'status' },
  // },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
];


export default {
  name: "TextbookEdit",
  components: {
    Upload: Upload,
    CommonPermissions: CommonPermissions
  },
  data() {
    return {
      publishModalVisible: false,
      auditStatusStat: [],
      activeStatKey: undefined,
      publisherCompanyList: [],

      loading: false,
      columns,
      searchKey: undefined,
      currentPage: 1,
      total: 0,
      textbookList: [],

      selectCategoryId: undefined,
      showEditModal: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      queryData: {
        title: undefined,
        author: undefined,
        publisherCompanyId: undefined,
        eduStage: undefined,
      },
      queryExData: {
        auditStatus: undefined,
        onlineStatus: undefined,
      },
      form: getEmptyTextbookForm(),
      showCategoryTagModal: false,
      categoryTagSubmitting: false,
      currentCategoryTagTextbookId: undefined,
      categoryTagForm: {
        bookType: 1,
        categoryIds: [],
        tagIds: [],
      },
      categoryOptions: [],
      tagOptions: [],
      defaultThumb,
      bookFormatOptions,
      thumbPreviewVisible: false,
      thumbPreviewUrl: '',
      thumbPreviewTitle: '',
    }
  },
  computed: mapState({
    // textbookCategory: state => state.textbook.category,
    // textbookList: state => state.textbook.list,
  }),
  created() {
    const {id} = this.$route.query;
    console.log(333)
  },
  async mounted() {
    await this.getPublisherCompany()
    await this.$store.dispatch('textbook/getCategory')
    await this.getStatData()
  },
  methods: {
    async confirmPublich(textbook) {
      console.log(textbook)
      this.loading = true
      let resp = await textBookApi.releaseVersion(textbook.id, textbook.latestVersion.id)
      this.loading = false
      await this.searchTextbook()
    },
    async withdrawVersion(textbook) {
      let resp = await textBookApi.withdrawVersion(textbook.id, textbook.latestVersion.id)
      console.log(resp)
      await this.searchTextbook()
    },
    async getPublisherCompany() {
      let resp = await dictApi.getPublisherCompany()
      console.log(resp)
      this.publisherCompanyList = resp
    },
    async changeTab(key) {
      let auditStatusStatItem = this.auditStatusStat.find(item => {return item.label == key})
      this.activeStatKey = key
      console.log(auditStatusStatItem)
      this.queryExData.auditStatus = auditStatusStatItem.auditStatus
      this.queryExData.onlineStatus = auditStatusStatItem.onlineStatus
      await this.getBookList(1)
    },
    async searchTextbook() {
      console.log(this.queryData)
      await this.getStatData()
    },
    async getStatData() {
      this.loading = true
      let resp = await textBookApi.getTextBookAuditStatusStat(this.queryData)
      console.log(resp)
      this.auditStatusStat = resp
      for(let i = 0; i < resp.length; i++) {
        if(resp[i].count > 0) {
          this.changeTab(resp[i].label)
          this.loading = false
          return;
        }
      }
      this.loading = false
    },
    async getBookList(page) {
      this.loading = true
      let params = Object.assign({}, this.queryData, this.queryExData)
      let resp = await textBookApi.findPagingTextBookWithLatestVersion(page, params)
      console.log(resp)
      this.textbookList = resp.list
      this.currentPage = resp.pageNum
      this.total = resp.total
      this.loading = false
    },
    async changePage(pagination) {
      console.log(pagination)
      await this.getBookList(pagination.current)
    },
    async triggerEditModal(id) {
      const opening = !this.showEditModal
      if(id){
        this.loading = true
        let resp = await textBookApi.findTextBookById(id)
        this.loading = false
        console.log(resp)
        if(resp.price){
          resp.price = resp.price / 100
        }
        this.form = Object.assign(getEmptyTextbookForm(), resp)
        if (resp.publisherCompany && resp.publisherCompany.id != null && (this.form.publisherCompanyId === undefined || this.form.publisherCompanyId === null)) {
          this.form.publisherCompanyId = resp.publisherCompany.id
        }
        this.form.categoryIds = undefined
        this.form.categoryId = 102
        this.form.aiTextbook = resp.aiTextbook === true
        this.form.standardType = resp.standardType != null ? Number(resp.standardType) : 0
        this.form.bookFormat = resp.bookFormat != null ? Number(resp.bookFormat) : 0
      } else if (opening) {
        // 仅「打开抽屉且为新增」时清空，避免关闭抽屉时清空正在编辑的数据
        this.form = getEmptyTextbookForm()
      }
      this.showEditModal = !this.showEditModal
    },
    async openCategoryTagModal(textbook) {
      this.currentCategoryTagTextbookId = textbook.id
      this.categoryTagForm = {
        bookType: textbook.bookType || 1,
        categoryIds: Array.isArray(textbook.categoryIds) ? [...textbook.categoryIds] : [],
        tagIds: Array.isArray(textbook.tagIds) ? [...textbook.tagIds] : [],
      }
      this.showCategoryTagModal = true
      this.loading = true
      try {
        const detail = await textBookApi.findTextBookById(textbook.id)
        this.categoryTagForm.bookType = detail.bookType || this.categoryTagForm.bookType || 1
        this.categoryTagForm.categoryIds = Array.isArray(detail.categoryIds) ? [...detail.categoryIds] : []
        this.categoryTagForm.tagIds = Array.isArray(detail.tagIds) ? [...detail.tagIds] : []
        await this.loadCategoryOptionsByBookType(this.categoryTagForm.bookType)

        const tagResp = await textBookApi.findTextbookTagList({})
        this.tagOptions = (Array.isArray(tagResp) ? tagResp : []).map((item) => ({
          value: item.id,
          label: item.name,
        }))
      } finally {
        this.loading = false
      }
    },
    closeCategoryTagModal() {
      this.showCategoryTagModal = false
      this.categoryTagForm = { bookType: 1, categoryIds: [], tagIds: [] }
      this.currentCategoryTagTextbookId = undefined
    },
    async handleCategoryBookTypeChange(bookType) {
      await this.loadCategoryOptionsByBookType(bookType)
      this.categoryTagForm.categoryIds = []
    },
    handleCategoryChange(values) {
      this.categoryTagForm.categoryIds = Array.isArray(values) ? values : []
    },
    async loadCategoryOptionsByBookType(bookType) {
      const categoryResp = await textBookApi.textBookCategoryList({ bookType })
      this.categoryOptions = buildCategoryDisplayOptions(Array.isArray(categoryResp) ? categoryResp : [])
      const validIds = new Set(this.categoryOptions.map((item) => item.value))
      this.categoryTagForm.categoryIds = (this.categoryTagForm.categoryIds || []).filter((id) => validIds.has(id))
    },
    async saveCategoryAndTag() {
      if (!this.currentCategoryTagTextbookId || this.categoryTagSubmitting) {
        return
      }
      this.categoryTagSubmitting = true
      try {
        const selectedCategoryIds = Array.isArray(this.categoryTagForm.categoryIds) ? this.categoryTagForm.categoryIds : []
        await textBookApi.updateTextBookCategoryAndTag(this.currentCategoryTagTextbookId, {
          categoryIds: selectedCategoryIds,
          tagIds: this.categoryTagForm.tagIds || [],
        })
        this.$message.success('教材分类与标签保存成功')
        this.closeCategoryTagModal()
        await this.searchTextbook()
      } finally {
        this.categoryTagSubmitting = false
      }
    },
    async saveTextbook() {
      if(this.loading){
        return
      }
      this.loading = true
      console.log(this.form)
      let body = Object.assign({}, this.form)
      body.aiTextbook = !!this.form.aiTextbook
      body.standardType =
        this.form.standardType !== undefined &&
        this.form.standardType !== null &&
        this.form.standardType !== ''
          ? Number(this.form.standardType)
          : 0
      body.bookFormat =
        this.form.bookFormat !== undefined &&
        this.form.bookFormat !== null &&
        this.form.bookFormat !== ''
          ? Number(this.form.bookFormat)
          : 0
      if(body.price){
        body.price = body.price * 100
      }
      body.bookType = 1
      if(this.form.id){
        if(this.form.thumbUrl){

        }
        body.thumbUrl = undefined
        console.log(body)
        await textBookApi.updateTextBook(body.id, body)
      }else{
        await textBookApi.addTextBook(body)
      }
      this.loading = false
      this.form = getEmptyTextbookForm()
      // this.form.categoryId = this.form.categoryIds[this.form.categoryIds.length - 1]
      this.triggerEditModal()
      await this.searchTextbook()
    },
    openThumbPreview(record) {
      const url = record && (record.thumbUrl || this.defaultThumb)
      this.thumbPreviewUrl = url || this.defaultThumb
      this.thumbPreviewTitle = (record && record.title) ? String(record.title) : '封面预览'
      this.thumbPreviewVisible = true
    },
    closeThumbPreview() {
      this.thumbPreviewVisible = false
      this.thumbPreviewUrl = ''
      this.thumbPreviewTitle = ''
    },
    goTextbookEdit(textbookId) {
      // console.log(this.$router.push({name: 'TextbookChapter', params: {id: textbookId}}))
      console.log(this.$router.push({name: 'TextbookEdit', params: {id: textbookId}}))
    },
    goTextbookAudit(textbook) {
      console.log(this.$router.push({name: 'TextbookChapter', params: {id: textbook.id}, query: {versionId: textbook.latestVersion.id}}))
    },
    async deleteTextbook(texebookId) {
      await textBookApi.deleteTextBook(texebookId)
      await this.searchTextbook()
    },
    changeImgUri(uri) {
      console.log(uri)
      this.form.thumbUri = uri
    },
    getBookFormatLabel,
  }
}
</script>

<style lang="less" scoped>
.flex-item {
  display: flex;
  margin-bottom: 24px;
  margin-right: 0;
}

.thumb-cell {
  width: auto;
  height: 30px;
  object-fit: contain;
}

.thumb-clickable {
  cursor: pointer;
}

.thumb-preview-wrap {
  text-align: center;
}

.thumb-preview-img {
  width: 100%;
  max-height: 70vh;
  object-fit: contain;
}
</style>